import React from 'react'
import Modal from 'react-modal';
import {locale} from '../locale/AppLocale'
import axios from 'axios'
import Config from '../Helpers/Config'

import {connect} from 'react-redux'
import {check,requiresRelogin} from '../actions/authActions'
import {NotificationManager} from '../Helpers/NotificationManager';
import Loader from '../Components/Loader'

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content: {
        overflow: '',
        top: '',
        left: '',
        right: '',
        bottom: '',
        marginRight: '',
        transform: '',
        padding: '',
        border: '',
        background: '',
        borderRadius: '',
    }
};

class EmailConfirm extends React.Component {
    constructor(props) {
        super(props);
        let isOpen = props.opened || false;
        this.state = {
            modalIsOpen: isOpen,
            activation_code: '',
            activating: false,
            sending: false
        };

        this.closeModal = this.closeModal.bind(this);

        this.activate = this.activate.bind(this)
        this.sendActivationCode = this.sendActivationCode.bind(this)
    }


    closeModal(proxy) {
        this.setState({modalIsOpen: false});
    }

    render() {
        return (
            <div>
                <Modal
                    portalClassName={'shooq-modal'}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    contentLabel={locale.get('mobile_confirm_title')}
                    shouldCloseOnOverlayClick={false}
                >
                    <div className="shooq-modal--box">
                        <div className="shooq-modal--header">
                            <div className="shooq-modal--header--title">{locale.get('email_confirm_title')}</div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="shooq-modal--body">
                            <p>{locale.get('email_confirm_required_to_sell',{email:this.props.auth.user.email})}</p>
                        </div>
                        <div className="clearfix"></div>
                        <div className="shooq-modal--footer">
                            <button className="btn-1" onClick={this.activate} disabled={this.activating}>
                                <Loader completed={this.state.activating === false}/>
                                {locale.get('done')}
                            </button>
                            <button
                                disabled={this.state.sending}
                                className="btn-2"
                                onClick={this.sendActivationCode}
                                style={{float: 'left'}}>
                                <Loader completed={this.state.sending === false}/>
                                {locale.get('resend_email_activation')}
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }


    activate() {
        location.reload();

    }

    sendActivationCode() {

        this.setState({
            sending: true
        });

        axios.post(Config.mainUrl('user/ajax/send/email-confirmation'), {},
            {
                withCredentials: Config.withCredentials(),
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then((response) => {
            NotificationManager.success(response.data.message)
            this.setState({
                sending: false
            })
        }).catch((error) => {
            if(error.response.status === 401) {
                this.props.requiresReLogin();
            }else {
                if (error.response.data) {
                    NotificationManager.error(error.response.data.message)
                }
            }
            this.setState({
                sending: false
            })
        })
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    checkAuth: () => dispatch(check()),

    requiresReLogin: ()=>dispatch(requiresRelogin(true,true))
});
export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirm);
